import { Routes } from '@angular/router';
import { HomeComponent } from 'src/app/pages/home/home.component';

export const ROUTE_PATHS = {
  HOME: '',
}

export const routes: Routes = [
  { path: ROUTE_PATHS.HOME, component: HomeComponent },
];
